import { useLocale } from 'src/lib/hooks/useLocal'
import { useRTOSuitePermissions } from 'src/lib/access-permission-hooks/useRTOSuitePermissions'
import RTOSuiteSetupDialog from '../orders/RTOSuiteSetupDialog'
import { useState } from 'react'
import { useRouter } from 'next/router'
import { ArrowUpRight, Lock } from 'react-feather'
import { useOrganisationContext } from 'src/lib/contexts/OrganisationContext'
import { ActivityLogPayloadType } from 'src/lib/types/activityLogTypes'
import { EntityName } from 'src/lib/hooks/useActivityLogs'
import useNavigation from 'src/lib/hooks/useNavigation'

const EnableRtoRiskProfiling = () => {
  const [open, setOpen] = useState(false)
  const { t } = useLocale()

  const {
    state: { shopfloApps }
  } = useOrganisationContext()
  const {
    actions: { resetAndRedirect }
  } = useNavigation()

  const isRtoRiskScoringInstalled = Boolean(
    shopfloApps?.find(item => item.name === 'RTO_RISK_SCORING' && item.merchantAppDetails.active)
  )

  const handleRedirectToRtoRiskScoringApp = () => {
    const appId = shopfloApps?.find(item => item.name === 'RTO_RISK_SCORING')?.id
    resetAndRedirect(`/app-store/app?id=${appId}`)
  }

  const activityLogPayload: ActivityLogPayloadType = {
    entityName: EntityName.RTO_SUITE,
    actionName: 'enabled rto risk profiling'
  }

  return (
    <>
      {!isRtoRiskScoringInstalled && (
        <div className='flex flex-col gap-4 justify-between'>
          <div className='flex flex-col gap-1 text-sm'>
            <h2 className='font-medium text-carbon'>{t('enable_rto_risk_profiling')}</h2>
            <p className='font-normal leading-5 text-gray-dark'>{t('enable_rto_risk_prifiling_description')}</p>
          </div>
          <div className='flex p-2 justify-between items-center border border-gray-light rounded-lg'>
            <div className='flex flex-row space-x-2 items-center justify-start'>
              <div className={'flex items-center justify-center rounded-lg p-2 bg-yellow-faintest'}>
                <Lock size={16} className='text-yellow-dark' strokeWidth={2.5} />
              </div>
              <div className='flex flex-col space-y-1'>
                <p className='text-sm text-coal-dark font-medium'>{t('enable_shopflo_network_intelligence')}</p>
                <span className='text-xs text-coal-light font-normal'>{t('powered_by_brands_and_customers')}</span>
              </div>
            </div>
            <button
              className='flex items-center justify-center bg-white rounded-lg py-2 px-3 border border-gray-light text-sm text-coal-dark font-medium'
              onClick={handleRedirectToRtoRiskScoringApp}
            >
              <span>{t('enable')}</span>
              <ArrowUpRight size={16} className='text-coal-dark' strokeWidth={2.5} />
            </button>
          </div>
        </div>
      )}

      {isRtoRiskScoringInstalled && (
        <div className='flex flex-row justify-between'>
          <div className='flex flex-col gap-0.5 text-sm'>
            <h2 className='font-medium text-carbon'>{t('rto_risk_setup')}</h2>
            <p className='font-normal leading-5 text-gray-dark'>{t('configure_risk_threshold_and_settings')}</p>
          </div>

          <button
            className='flex w-fit items-center gap-1 text-sm font-semibold cursor-pointer p-2 rounded-lg border-1 hover:ring-2 hover:ring-coal-lighter transition-all duration-200'
            onClick={() => setOpen(true)}
          >
            {t('configure')}
          </button>
        </div>
      )}

      <RTOSuiteSetupDialog open={open} setOpen={setOpen} activityLogPayload={activityLogPayload} />
    </>
  )
}

export default EnableRtoRiskProfiling
